import {Emisor} from './emisor';

export class GrePoint {
    id: any;
    code: string;
    address: string;
    ubigeo: string;
    startingPoint: any;
    arrivalPoint: any;
    constructor() {
        this.code = '0000';
        this.address = '';
        this.ubigeo = '';
        this.startingPoint = 'NO';
        this.arrivalPoint = 'NO';
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/recursos/modelo/gre-point.ts